"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialTrackerCustomCommandRequestT = exports.SerialTrackerCustomCommandRequest = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * Sends a custom cmd to the currently connected Tracker over the Serial Monitor
 */
class SerialTrackerCustomCommandRequest {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSerialTrackerCustomCommandRequest(bb, obj) {
        return (obj || new SerialTrackerCustomCommandRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSerialTrackerCustomCommandRequest(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SerialTrackerCustomCommandRequest()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    command(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    static startSerialTrackerCustomCommandRequest(builder) {
        builder.startObject(1);
    }
    static addCommand(builder, commandOffset) {
        builder.addFieldOffset(0, commandOffset, 0);
    }
    static endSerialTrackerCustomCommandRequest(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSerialTrackerCustomCommandRequest(builder, commandOffset) {
        SerialTrackerCustomCommandRequest.startSerialTrackerCustomCommandRequest(builder);
        SerialTrackerCustomCommandRequest.addCommand(builder, commandOffset);
        return SerialTrackerCustomCommandRequest.endSerialTrackerCustomCommandRequest(builder);
    }
    unpack() {
        return new SerialTrackerCustomCommandRequestT(this.command());
    }
    unpackTo(_o) {
        _o.command = this.command();
    }
}
exports.SerialTrackerCustomCommandRequest = SerialTrackerCustomCommandRequest;
class SerialTrackerCustomCommandRequestT {
    constructor(command = null) {
        this.command = command;
    }
    pack(builder) {
        const command = (this.command !== null ? builder.createString(this.command) : 0);
        return SerialTrackerCustomCommandRequest.createSerialTrackerCustomCommandRequest(builder, command);
    }
}
exports.SerialTrackerCustomCommandRequestT = SerialTrackerCustomCommandRequestT;
